import StatusButton from "./status-button";

const LabelWithStatus = ({
  id,
  label,
  required = false,
  fieldData = {},
  handleStatusClick,
}) => {
  return (
    <div className="flex mb-1 items-center justify-between">
      <label
        htmlFor={id}
        className="text-sm text-labelColour whitespace-normal break-words"
      >
        <span className="inline">
          {label}
          {required && <span className="text-red-500">*</span>}
        </span>
      </label>
      {(fieldData?.comments?.length > 0 || fieldData?.status == "approved") && (
        <StatusButton
          status={fieldData?.status}
          count={fieldData?.comments?.length || 0}
          openSection={() =>
            handleStatusClick(fieldData, label, fieldData?.value, "")
          }
        />
      )}
    </div>
  );
};

export default LabelWithStatus;
